
import React from 'react'
import { ContentCopy} from "@mui/icons-material"
import {CustomTooltip} from  '../customtooltip/CustomTooltip'
import StatusContext from '../../../contexts/StatusContext'
import CopyWithTimeout from './CopyWithTimeout';

import "./customicons.css"

export const CopyTextIconComprehensiveResponses = ({ prompt }) => {
  let {
    isLoading,
    changeLanguage,
    isTextCopied,
    onCopy,
} = React.useContext(StatusContext); 

  return (
   
    <div>
       {
          ( !isTextCopied.status || isTextCopied.id !== prompt.id) && 
              <>
              <div>
                <CustomTooltip title={changeLanguage('status', 'copy')}>
                  <ContentCopy
                    className="promptIconColoredOrange"
                    style = {{marginBottom: '5px'}}
                    onClick={() => {
                      !isLoading && onCopy(prompt);
                    }}
                  />
                </CustomTooltip>
              </div>
              </>
        }  
        {
          (isTextCopied.id === prompt.id && isTextCopied.status) && 
              <CopyWithTimeout />
        }
    </div> 

  )
}
  




